/* eslint-disable no-else-return */
import isEmpty from "lodash-es/isEmpty"

import { EPath } from "@/3514/constants"
import type { IEnrollmentModel, IUserCoachModel, IUserModel, IUserParticipantModel } from "@/3514/types"
import { isUserAssistant, isUserCoach, isUserManager } from "@/3514/utils"
import { CoachUrls, ParticipantUrls } from "@/constants"
import { EStorageServiceType, SessionStorageServiceKeys, StorageService } from "@/services"

const sessionStorageService: StorageService = new StorageService(EStorageServiceType.Session)

export const getIndexPage = (user: IUserModel, showDashboard) => {
    const isCoach: boolean = isUserCoach(user) || isUserManager(user)
    const isParticipant: boolean = isUserCoach(user) || isUserManager(user)
    const isAssistant: boolean = isUserAssistant(user)

    if (isAssistant) return EPath.Assistant_Participants()

    if (isCoach) {
        if (
            sessionStorageService.getItem(SessionStorageServiceKeys.FakeParticipantsFeatureEnabled()) ||
            (user as IUserCoachModel)?.areSubUsersPresent
        )
            return CoachUrls.WELCOME

        return EPath.Coach_Dashboard({ tab: "Sessions" })
    }

    if (isParticipant) {
        if ((user as IUserParticipantModel).isOnboardingFinished) return EPath.Participant_OnboardingRedirect()
        if ((user as IUserParticipantModel).areNotCompletedSurveysPresent) return ParticipantUrls.SURVEYS
    }

    if (showDashboard) {
        if ((user as IUserParticipantModel).areModulesAvailable) {
            if (!isEmpty((user as IUserParticipantModel).currentModule))
                return EPath.Participant_DashboardModule((user as IUserParticipantModel).currentModule.rank)
            else {
                const lastEnrolledModule: IEnrollmentModel = (user as IUserParticipantModel).enrollments?.findLast(
                    ({ status }: IEnrollmentModel): boolean => status !== "unassigned"
                )

                if (!isEmpty(lastEnrolledModule)) return EPath.Participant_DashboardModule(lastEnrolledModule.rank)
            }

            return EPath.Participant_Dashboard()
        }
    }

    return EPath.Participant_CoachingSessions()
}
